import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const STORAGE_KEY = "dhruva_portal_token";

export const getPortalToken = () => localStorage.getItem(STORAGE_KEY);
export const setPortalToken = (t) => {
  if (t) localStorage.setItem(STORAGE_KEY, t);
  else localStorage.removeItem(STORAGE_KEY);
};

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = getPortalToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default client;

export const portalLogin = async (email, password) => {
  const r = await axios.post(`${API}/admin/login`, { email, password });
  setPortalToken(r.data.token);
  return r.data;
};

export const portalLogout = () => setPortalToken(null);

export const decodeJWT = (token) => {
  try {
    const payload = token.split(".")[1];
    return JSON.parse(atob(payload.replace(/-/g, "+").replace(/_/g, "/")));
  } catch {
    return null;
  }
};

export const getCurrentPortalUser = () => {
  const t = getPortalToken();
  if (!t) return null;
  const p = decodeJWT(t);
  if (!p) return null;
  if (p.exp && Date.now() / 1000 > p.exp) {
    setPortalToken(null);
    return null;
  }
  return { id: p.sub, email: p.email, role: p.role, name: p.name };
};
